import ApiService from "@/services/ApiService"

const PACIENTE_REPOSITORY_URL = 'Paciente'

const PacienteRepository = {

  obtenerListaPaciente(){
    return ApiService.get(`${PACIENTE_REPOSITORY_URL}/ObtenerPacienteList`)
  },

  agregarPaciente(data){
    return ApiService.post(`${PACIENTE_REPOSITORY_URL}/AgregarPaciente`,data)
  },

  quitarPaciente(pIDPaciente){
    let data = {
      pIDPaciente
    }
    return ApiService.delete(`${PACIENTE_REPOSITORY_URL}/QuitarPaciente`,data)
  },

}

export default PacienteRepository